import { z } from 'zod'
import type { ApiClient } from '../apiClient'

export const knownUserSchema = z.object({
  user_email: z.string(),
  user_auth_id: z.string(),
})
export type KnownUser = z.infer<typeof knownUserSchema>

export const collectionShareSchema = z.object({
  collection_id: z.string(),
  user_id: z.string(),
  user_email: z.string().nullable(),
})
export type CollectionShare = z.infer<typeof collectionShareSchema>

export async function listKnownUsers(client: ApiClient): Promise<KnownUser[]> {
  const raw = await client.get<unknown>('/v_known_users', { order: 'user_email.asc' })
  return z.array(knownUserSchema).parse(raw)
}

export async function listCollectionShares(
  client: ApiClient,
  collectionId: string,
): Promise<CollectionShare[]> {
  const raw = await client.get<unknown>('/v_collection_shares', {
    collection_id: `eq.${collectionId}`,
  })
  return z.array(collectionShareSchema).parse(raw)
}

export async function shareCollection(
  client: ApiClient,
  collectionId: string,
  userAuthId: string,
): Promise<void> {
  await client.post('/uservar', { collection_id: collectionId, user_id: userAuthId })
}

export async function unshareCollection(
  client: ApiClient,
  collectionId: string,
  userAuthId: string,
): Promise<void> {
  await client.delete('/uservar', {
    collection_id: `eq.${collectionId}`,
    user_id: `eq.${userAuthId}`,
  })
}
